import { createAsyncAction } from 'src/redux/actions';
import { SearchQueryParams } from 'src/types/search';

export const FetchSearchResults = createAsyncAction(
  'search/FETCH_SEARCH_RESULTS'
);

export const fetchSearchResults = (searchParams: SearchQueryParams) => ({
  type: FetchSearchResults.REQUEST,
  payload: {
    ...searchParams,
  },
});
